import React from 'react';
import { Info } from 'lucide-react';
import {
  Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from '@/components/ui/tooltip';

const InfoTip = ({ text, side = 'top' }) => (
  <TooltipProvider delayDuration={200}>
    <Tooltip>
      <TooltipTrigger asChild>
        <Info className="h-3.5 w-3.5 text-gray-400 hover:text-gray-600 cursor-help inline-block ml-1 flex-shrink-0" data-testid="info-tip" />
      </TooltipTrigger>
      <TooltipContent side={side} className="max-w-xs text-xs">
        <p>{text}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default InfoTip;
